import type { AppDef } from "../../shell/nav";
import { MailInboundPage } from "./MailInboundPage";
import { MailRulesPage } from "./MailRulesPage";
import { MailStatusPage } from "./MailStatusPage";
import { MailDownloadsPage } from "./MailDownloadsPage";
import { DevicesPage } from "./DevicesPage";
import { OverviewPage } from "./OverviewPage";
import { PoliciesPage } from "./PoliciesPage";
import { ScansPage } from "./ScansPage";
import { SettingsPage } from "./SettingsPage";
import { UploadDomainsPage } from "./UploadDomainsPage";
import { UploadEventsPage } from "./UploadEventsPage";
import { UsbEventsPage } from "./UsbEventsPage";

/** DLP の 4 機能のどれかがあれば出す画面(概要・端末・設定)。 */
const ANY_DLP = ["dlp.exit-scan", "dlp.usb", "dlp.upload", "dlp.mail"];

export const DLP: AppDef = {
  key: "dlp",
  name: "DLP",
  // 契約(docs/dlp.md §10)の `/dlp` = 概要。index ルートと衝突するので `overview` に置き、`/dlp` から転送する
  defaultPath: "overview",
  groups: [
    {
      label: "状況",
      items: [
        { path: "overview", label: "概要", phase: "R6c", component: OverviewPage, feature: ANY_DLP },
        { path: "devices", label: "端末", phase: "R6c", component: DevicesPage, feature: ANY_DLP },
      ],
    },
    {
      label: "退職時検査",
      items: [
        { path: "scans", label: "退職時スキャン", phase: "R6c", component: ScansPage, feature: "dlp.exit-scan" },
        // 表示は viewer でもよい(編集ボタンは admin だけ)
        { path: "policies", label: "検査ポリシー", phase: "R6c", component: PoliciesPage, feature: "dlp.exit-scan" },
      ],
    },
    {
      label: "アップロード",
      items: [
        { path: "upload", label: "アップロード検知", phase: "R6c", component: UploadEventsPage, feature: "dlp.upload" },
        // 表示は viewer でもよい(追加・編集は admin だけ。docs/dlp-upload.md §10)
        { path: "upload/domains", label: "送信先の一覧", phase: "R6c", component: UploadDomainsPage, feature: "dlp.upload" },
      ],
    },
    {
      label: "メール",
      items: [
        { path: "mail/rules", label: "メール規則", phase: "R6c", component: MailRulesPage, feature: "dlp.mail" },
        { path: "mail/status", label: "メールの状態", phase: "R6c", component: MailStatusPage, feature: "dlp.mail" },
        // 受信の記録は admin だけ(dlp-inbound-log §7)。送信側の dlp.mail とは別の機能
        { path: "mail/inbound", label: "受信の記録", phase: "R6c", component: MailInboundPage, role: "dlp:admin", feature: "dlp.mail_inbound" },
        // 添付ダウンロードリンクの取り出し記録(設計 §10.1〜10.2)。viewer は集計、approver は全記録。送信者本人の分は「自分の記録」
        { path: "mail/downloads", label: "ダウンロード記録", phase: "R6c", component: MailDownloadsPage, feature: "dlp.mail" },
      ],
    },
    {
      label: "USB・設定",
      items: [
        { path: "usb", label: "USB 利用ログ", phase: "R6c", component: UsbEventsPage, feature: "dlp.usb" },
        { path: "settings", label: "設定", phase: "R6c", component: SettingsPage, role: "dlp:admin", feature: ANY_DLP },
      ],
    },
  ],
};
